import { Box, Shimmer } from "@jewlr/storybook/core"
import React from "react"

import { IS_JEWLR } from "helpers/application"

const WizardPricingLoading = () => {
  return (
    <Box mb={{ _: 2, tablet: "12px" }} mt={{ _: 1, tablet: 0 }}>
      <Shimmer
        borderRadius="4px"
        height={IS_JEWLR() ? { _: "58px", tablet: "48px" } : "32px"}
        mb={{ tablet: "12px" }}
        width="100%"
      />
    </Box>
  )
}

export default WizardPricingLoading
